import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import ProductLabelTemplate from '@square/dashboard-items-data/models/squareup/inventory/v3/product-label-template';
import ProductLabelConfiguration from '@square/dashboard-items-data/models/squareup/inventory/v3/product-label-configuration';
export default ProtoBaseModel.extend({
  template: attr(ProductLabelTemplate),
  configuration: attr(ProductLabelConfiguration)
});